import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["css", "asChild", "as", "style", "className", "name", "hasError", "options", "isMulti", "value", "id", "inputId", "openMenuOnClick", "onChange", "disabled", "isClearable", "renderOption", "menuPlacement", "menuPosition", "portalMenu", "icon"];
import React from "react";
import SelectPrimitive from "./primitives";
import { jsx as _jsx } from "react/jsx-runtime";
var Select = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var css = _ref.css,
    asChild = _ref.asChild,
    as = _ref.as,
    style = _ref.style,
    className = _ref.className,
    name = _ref.name,
    hasError = _ref.hasError,
    options = _ref.options,
    isMulti = _ref.isMulti,
    value = _ref.value,
    id = _ref.id,
    inputId = _ref.inputId,
    openMenuOnClick = _ref.openMenuOnClick,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    isClearable = _ref.isClearable,
    renderOption = _ref.renderOption,
    _ref$menuPlacement = _ref.menuPlacement,
    menuPlacement = _ref$menuPlacement === void 0 ? "auto" : _ref$menuPlacement,
    _ref$menuPosition = _ref.menuPosition,
    menuPosition = _ref$menuPosition === void 0 ? "absolute" : _ref$menuPosition,
    _ref$portalMenu = _ref.portalMenu,
    portalMenu = _ref$portalMenu === void 0 ? false : _ref$portalMenu,
    icon = _ref.icon,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(SelectPrimitive, _extends({
    id: id,
    inputId: inputId,
    value: value,
    openMenuOnClick: openMenuOnClick,
    name: name,
    onChange: onChange,
    ref: forwardedRef,
    options: options,
    disabled: disabled,
    "aria-invalid": hasError,
    isClearable: isClearable,
    isMulti: isMulti,
    renderOption: renderOption,
    icon: icon,
    valueRenderType: "default",
    portalMenu: portalMenu,
    menuPosition: menuPosition,
    menuPlacement: menuPlacement
  }, props));
});
Select.displayName = "Select";
export default Select;